
import React from 'react'
import { component_tool } from '../../../../tool'
let { WizDataTable, WizIcon, WizButton, WizDivider } = component_tool

export default (showDuration) => {
    const columns = [
        {
            title: "考核范围",
            name: "scope",
            dataIndex: "scope",
            tableItem: {},
            dict: [
              { code: 1, codeName: "销售" },
              { code: 2, codeName: "售后" },
              { code: 3, codeName: "销售售后" }
            ]
          },
          {
            title: "考核名称",
            name: "name",
            dataIndex: "name",
            tableItem: {},
          },
          {
            title: "品牌",
            name: "orgName",
            dataIndex: "orgName",
            tableItem: {},
          },
          {
            title: "岗位",
            name: "position",
            dataIndex: "position",
            tableItem: {},
          },
          showDuration ? 
          {
            title: "时长",
            name: "duration",
            dataIndex: "duration",
            tableItem: {},
          } : {} ,
          {
            title: "人数",
            name: "number",
            dataIndex: "number",
            tableItem: {},
          },
          {
            title: "剩余人数是否自动补充",
            name: "autoFill",
            dataIndex: "autoFill",
            tableItem: {},
            dict: [
              { code: 1, codeName: "是" },
              { code: 0, codeName: "否" }
            ]
          }
        ];

    return columns
}
